import React, { useState, useEffect } from 'react';
import './ARLoadingScreen.scss';
import { ARIconBig } from '../../../svg';
import { MasterButton } from '../../../react/components/button/MaterButton';
import { getVariants } from '../../../core/platforms/_Platform/getVariant';
import { IS_ANDROID, IS_IOS, IS_IPAD } from '../../../core/constant';
import axios from 'axios';



export function ARLoadingScreen(props) {
    const [productData, setProductData] = useState(null);

    const onLaunchClick = () => {
        if(!productData){
            return
        }
        if (IS_IOS || IS_IPAD) {
          startAR(productData.default_parts[0].external_url + '/model.usdz')
        }
        else if (IS_ANDROID){
          startAR(productData.default_parts[0].external_url + '/lod0_with_textures/mesh.gltf')
        }
    }



    const checkfileExist = (url) => {
      return new Promise(async (resolve, reject) => {
        axios
          .head(url)
          .then((response) => {
            resolve(true);
          })
          .catch((error) => {
            resolve(false);
          });
      });
    }
    const startAR = (url) => {
      if (IS_IOS || IS_IPAD) {
        if(checkfileExist(url)){
          startQuicklook(url);
        }
        else{
          window.alert("Sorry, model not avaiable")
        }
      } else if (IS_ANDROID) {
        if(checkfileExist(url)){
          startSceneViewer(url);
        }
        else{
          window.alert("Sorry, model not avaiable")
        }
      }
    }
    
    const startQuicklook = (url) => {
      const anchor = document.createElement('a');
      anchor.setAttribute('rel', 'ar');
      anchor.setAttribute('id', 'ar-link');
      anchor.appendChild(document.createElement('img'));
      if (anchor.relList.supports('ar')) {
          anchor.setAttribute('href', url + '#allowsContentScaling=0');
          anchor.click();
      }
    };
    
    const startSceneViewer = (url) => {
      const anchor = document.createElement('a');
      anchor.setAttribute(
          'href',
          `intent://arvr.google.com/scene-viewer/1.0?file=${
              url
          }&mode=ar_only#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=${window.location.href};end;`
      );
      anchor.click();
    };
  useEffect( () => {
    const fetchData = async () => {
        const data = await getVariants(parseInt(props.variantId))
        setProductData(data)
      }
      fetchData()
  }, [])
  return (
    <div className='ar-loading-screen'>

    <div className="ar-loading-screen-icon">
        <ARIconBig />
        </div>
        <p className="ar-loading-screen-title bitreel-viewer-text header-1 color-white">AR PRODUCT VIEW</p>
        <p className='ar-loading-screen-name bitreel-viewer-text body-1 color-white'>{ productData ? productData.name : "Loading..."}</p>
        {productData && 
        <MasterButton
            style={`mid-width-button`}
            onClick={()=>{ onLaunchClick()}}
            title={'LAUNCH AR'}
            textStyle="bitreel-viewer-text button-text"
            />}

    </div>
  );
}